import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter_pipe',
  pure: false, // Set to false to re-evaluate when data changes
})
export class FilterSearchPipe implements PipeTransform {
  transform(items: any[], searchText: string, field?: string): any[] {
    if (!items) return [];
    if (!searchText) return items;

    searchText = searchText.toLowerCase();

    // If field is provided (including dot notation like "fields.name")
    if (field) {
      return items.filter(item => {
        const value = this.getNestedValue(item, field);
        return value?.toString().toLowerCase().includes(searchText);
      });
    }

    // Default fallback search on commonly used fields
    return items.filter(
      item =>
        item?.field?.toLowerCase().includes(searchText) ||
        item?.event?.toLowerCase().includes(searchText) ||
        item?.name?.toLowerCase().includes(searchText) ||
        item?.created_by?.toLowerCase().includes(searchText)
    );
  }

  // Helper method to get nested property using dot notation
  private getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((acc, part) => acc?.[part], obj);
  }
}
